import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WebsocketRequest, WebsocketService } from "./websocket";

/* eslint-disable @typescript-eslint/naming-convention */
interface CellularRequestData {
    http_method: string;
    url_path: string;
    raw_body_content: {
        data?: Record<string, unknown>;
    };
}

type CellularRequest = WebsocketRequest & { celllink_data: CellularRequestData };

export enum CellularProviderType {
    VERIZON = "verizon",
    ATT = "att",
    BMOBILE = "bmobile",
    NONE = "none",
}
/* eslint-enable @typescript-eslint/naming-convention */

@Injectable({
    providedIn: "root",
})
export class CellularDbService {
    requestType = "celllink";

    constructor(private websocket: WebsocketService) {}

    private prepareCellularData(path: string, method = "GET", body = {}): CellularRequestData {
        return {
            /* eslint-disable @typescript-eslint/naming-convention */
            http_method: method,
            url_path: path,
            raw_body_content: body,
            /* eslint-enable @typescript-eslint/naming-convention */
        };
    }

    private makeRequest(data: CellularRequestData): Observable<any> {
        return this.websocket.makeRequest<CellularRequest>({
            /* eslint-disable @typescript-eslint/naming-convention */
            request_type: this.requestType,
            session_id: "",
            celllink_data: data,
            headers: null,
            metadata: {},
            /* eslint-enable @typescript-eslint/naming-convention */
        });
    }

    queryDevice$(deviceId: string, providerType: CellularProviderType): Observable<any> {
        const url = `/api/1.0/${providerType}/device_info/${deviceId}`;
        const data = this.prepareCellularData(url, "GET");
        return this.makeRequest(data);
    }

    activateDevice$(deviceData, providerType: CellularProviderType): Observable<any> {
        const url = `/api/1.0/${providerType}/activate`;
        const data = this.prepareCellularData(url, "POST", deviceData);
        return this.makeRequest(data);
    }

    deactivateDevice$(deviceData, providerType: CellularProviderType): Observable<any> {
        const url = `/api/1.0/${providerType}/deactivate`;
        const data = this.prepareCellularData(url, "POST", deviceData);
        return this.makeRequest(data);
    }
}
